// extracted by mini-css-extract-plugin
export default {"multiSelectWrapper":"custom-outline-boxes-module__multiSelectWrapper--m0Kyo","baseStyles":"custom-outline-boxes-module__baseStyles--Bp0AB"};